<template>
  <v-container fluid>
    <ActionBar :activeTab="activeTab" />

    <div :class="[
      'page__content',
      {
        'page__content--from-v4': noMainMenuFromV4
      }]">
      <v-tabs
        v-model="activeTab"
        slider-color="secondary"
        class="v-tabs-reports"
        :class="{ 'v-tabs-reports__hidden': !hasRole('billing', 'ROLE_GET_FINANCIAL_ACCOUNT_INCENTIVES') || !hasRole('billing', 'ROLE_GET_INCENTIVES') }"
      >
        <v-tab v-show="hasRole('billing', 'ROLE_GET_FINANCIAL_ACCOUNT_INCENTIVES')" ripple>
          {{ $t(`${namespace}.active`) }}
        </v-tab>

        <v-tab v-show="hasRole('billing', 'ROLE_GET_INCENTIVES')" ripple>
          {{ $t(`${namespace}.pending`) }}
        </v-tab>

        <v-tabs-items touchless>
          <v-tab-item v-if="hasRole('billing', 'ROLE_GET_FINANCIAL_ACCOUNT_INCENTIVES')">
            <Active v-if="activeTab === 0" />
          </v-tab-item>

          <v-tab-item v-if="hasRole('billing', 'ROLE_GET_INCENTIVES')">
            <Pending v-if="activeTab === 1" />
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { hasRole } from 'utils/functions'
import ActionBar from 'components/incentives/ActionBar'
import Active from 'components/incentives/active'
import Pending from 'components/incentives/pending'

export default {
  name: 'IncentivesPage',
  components: {
    ActionBar,
    Active,
    Pending
  },
  data () {
    return {
      namespace: 'Views.IncentivesPage',
      activeTab: 0
    }
  },

  computed: {
    ...mapState({
      noMainMenuFromV4: ({ mainMenu }) => mainMenu.noMainMenuFromV4
    })
  },

  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    handleActiveTab () {
      if (
        this.hasRole('billing', 'ROLE_GET_FINANCIAL_ACCOUNT_INCENTIVES') &&
        this.hasRole('billing', 'ROLE_GET_INCENTIVES')
      ) {
        this.activeTab = 0
        return
      }

      if (
        !this.hasRole('billing', 'ROLE_GET_FINANCIAL_ACCOUNT_INCENTIVES') &&
        this.hasRole('billing', 'ROLE_GET_INCENTIVES')
      ) {
        this.activeTab = 1
      }
    }
  },
  mounted () {
    this.handleActiveTab()
  }
}
</script>

<style lang="scss">
.route--incentives {

  .page__content,
  .v-tabs-reports,
  .v-tabs-reports .v-window,
  .v-tabs-reports .v-window .v-window__container,
  .v-tabs-reports .v-window .v-window__container .v-window-item,
  .v-tabs-reports .v-window .v-window__container .v-window-item > div {
    height: 100%;
  }

  .v-tabs-reports__hidden {

    .v-tabs__bar {
      display: none !important;
    }
  }
}
</style>
